<template>
    <div class="transfer-candidate">
        <el-form
            ref="transferForm"
            :model="form"
            :rules="rules"
            label-position="top"
            class="transfer-form"
        >
            <div class="form-grid">
                <div class="form-item">
                    <el-form-item  prop="area_id">
                        <b>Khu vực điều chuyển <span class="text-danger">*</span></b>
                        <el-select
                            v-model="form.area_id"
                            class="w-100"
                            placeholder="Chọn khu vực muốn điều chuyển"
                            filterable
                            clearable
                            @change="handleChangeArea(form.area_id); form.office_id = ''"
                        >
                            <el-option
                                v-for="item in areas"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                    </el-form-item>
                </div>

                <div class="form-item">
                    <el-form-item prop="office_id">
                        <b>Văn phòng điều chuyển <span class="text-danger">*</span></b>
                        <el-select
                            v-model="form.office_id"
                            class="w-100"
                            placeholder="Chọn văn phòng muốn điều chuyển"
                            filterable
                            clearable
                            :disabled="!form.area_id"
                        >
                            <el-option
                                v-for="item in branches"
                                :key="item.id"
                                :label="item.name_alias || item.name"
                                :value="item.id"
                            />
                        </el-select>
                    </el-form-item>
                </div>
            </div>

            <div class="form-row">
                <el-form-item
                    prop="study_status"
                    class="status-item"
                >
                    <b>Trạng thái học tập sau điều chuyển <span class="text-danger">*</span></b>
                    <el-select
                        v-model="form.study_status"
                        class="w-100"
                        placeholder="Chọn trạng thái học tập"
                        clearable
                    >
                        <el-option
                            v-for="item in studyStatusOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>

                </el-form-item>
            </div>
            <p class="text-danger w-100">* Nếu khu vực điều chuyển có khóa học đào tạo khác với khu vực hiện tại thì khóa học sẽ mặc định được học lại</p>

            <hr>

            <div class="action-group">
                <el-button size="medium" style="background-color: #CACACA" class="rounded" @click="handleClose">Hủy bỏ</el-button>
                <el-button @click="handleSubmit()" size="medium"
                           class="text-white rounded" style="background-color: #5D04B0"
                           :loading="loadingSubmit"
                           :disabled="loadingSubmit">Xác nhận
                </el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
import { GET_REGIONS_BY_USER } from "../../../../core/services/store/customer/customer.module";
import {BRANCH_LIST} from "../../../../core/services/store/service.module";

export default {
    name: 'DialogTransferCandidate',
    props: {
        is_show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loadingSubmit: false,
            areas: [],
            branches: [],
            form: {
                area_id: '',
                office_id: '',
                study_status: ''
            },
            studyStatusOptions: [
                { label: 'Giữ nguyên trạng thái học tập', value: 'keep_learning' },
                { label: 'Học lại', value: 'relearn' }
            ],
            rules: {
                area_id: [
                    { required: true, message: 'Vui lòng chọn khu vực điều chuyển', trigger: 'change' }
                ],
                office_id: [
                    { required: true, message: 'Vui lòng chọn văn phòng điều chuyển', trigger: 'change' }
                ],
                study_status: [
                    { required: true, message: 'Vui lòng chọn trạng thái học tập', trigger: 'change' }
                ]
            }
        };
    },
    watch: {
        is_show: {
            handler(newVal) {
                if (newVal) {
                    this.resetForm();
                    this.getAreas();
                    this.loadingSubmit = false;
                }
            },
            immediate: true
        }
    },
    methods: {
        resetForm() {
            this.form = {
                area_id: '',
                office_id: '',
                study_status: ''
            };

            this.$nextTick(() => {
                if (this.$refs.transferForm) {
                    this.$refs.transferForm.clearValidate();
                }
            });
        },

        getAreas() {
            this.$store.dispatch(GET_REGIONS_BY_USER, { all: true }).then((response) => {
                if (response.status === 422) {
                    this.$message({
                        type: 'warning',
                        message: response.message,
                        showClose: true
                    });
                    return;
                }

                this.areas = response.data || [];
            }).catch(() => {
                this.areas = [];
            });
        },

        handleChangeArea(areaId) {
            this.$store.dispatch(BRANCH_LIST,{area_id: areaId})
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.branches = response.data;
                    }
                })
        },

        handleClose() {
            this.$emit('close');
        },

        handleSubmit() {
            this.$refs.transferForm.validate((valid) => {
                if (!valid) return;

                this.loadingSubmit = true;

                const payload = {
                    area_id: this.form.area_id,
                    branch_id: this.form.office_id,
                    study_status: this.form.study_status
                };

                this.$emit('confirm-tranfe-candidate', payload);

            });
        }
    }
};
</script>

<style scoped>
.transfer-candidate {
    padding: 4px 0 0;
}

.transfer-form {
    width: 100%;
}

.form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}

.form-row {
    margin-top: 4px;
    max-width: 50%;
}

.form-item,
.status-item {
    width: 100%;
}

.action-group {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.w-100 {
    width: 100%;
}

::v-deep .el-form-item__label {
    padding-bottom: 6px;
    font-weight: 500;
    color: #303133;
}

::v-deep .el-input__inner,
::v-deep .el-select .el-input__inner {
    height: 36px;
    line-height: 36px;
}

@media (max-width: 768px) {
    .form-grid {
        grid-template-columns: 1fr;
    }

    .form-row {
        max-width: 100%;
    }

    .action-group {
        justify-content: center;
    }
}
</style>
